import { css } from 'styled-components';
import { map } from '../../breakpoint';
export const zIndex = ()=>css`
  ${({ zIndex })=>map(zIndex, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
        )=>val !== undefined && css`
          z-index: ${val};
        `)};
`;

//# sourceMappingURL=z-index.js.map